window.replaceDomElement = function (data, element) {
    if (data && element) {
        let spanWrapper = document.createElement('span')
        spanWrapper.innerHTML = data
        element.replaceWith(spanWrapper)
    }
}

window.logoutSSOUser = function(link) {
    $.ajax({
        url: "/logout/ajax",
        type: 'POST',
        data: {},
        success: function(result) {
            window.location.href = link
        },
        error: function(error){
            console.log("Error: ", error)
        }
    });
}

window.openShoppingCart = function() {
    if(window.User.id !== 0) {
        checkTabStatus();
    }

    const cart_items = localStorage.getItem('cart_items');

    if(!cart_items || cart_items === '[]') {
        return;
    }

    // reuse same modal which is used for single booking
    document.getElementById('bookingModal').showModal();
    $('#bookingModal #unitsTab a').click();

    $.ajax({
        type: 'POST',
        url: '/cart/items',
        data: {
            cart_items
        },
        success: function (response) {

            if(response.data.length === 0) {

                // in case user add items, which already bought, to cart before login
                for (let i = 0; i < response.removeFromCartItems.length; i++) {
                    removeItemFromCart(generateCartItemId(response.removeFromCartItems[i].id, response.removeFromCartItems[i].unit_type), response.removeFromCartItems[i].parent_unit_id);
                }

                document.getElementById('bookingModal').close();
                return;
            }

            window.cartItemsGlobal = response.data;
            
            // in case user add items, which already bought, to cart before login
            for (let i = 0; i < response.removeFromCartItems.length; i++) {
                removeItemFromCart(generateCartItemId(response.removeFromCartItems[i].id, response.removeFromCartItems[i].unit_type), response.removeFromCartItems[i].parent_unit_id);
            }
            
            // Destroy existing DataTable instance, if any
            if ($.fn.DataTable.isDataTable('#cart-items-table')) {
                $('#cart-items-table').DataTable().destroy();
            }

            showDtLoader('cart-items-table-container');

            const activeDatatableOptions = window.setDatatableOptions({
                tableContainer: 'cart-items-table-container',
                data: response.data,
                order: false,
                paging: false,
                info: false,
                searching: false,
                columns: [
                    {
                        'data': 'unit_type_label',
                    },
                    {
                        'data': 'name',
                    },
                    {
                        'data': 'price',
                    },
                    {
                        'data': 'id',
                        'className': 'not-exportable no-wrap text-center',
                        "render": function (data, type, row) {
                            return '<button onclick="showRemoveItemFromCartModal(\'' + generateCartItemId(row.id, row.unit_type) + '\', ' + row.parent_unit_id + ')"><i class="fa fa-trash"></i></button>';
                        }
                    }
                ],
                "createdRow": function( row, data, dataIndex ) {
                    // Set a unique ID for each row
                    $(row).attr('id', generateCartItemId(data.id, data.unit_type));
                }
            });

            $('#cart-items-table').DataTable(activeDatatableOptions);

            sumCartPrice();
            regenerateSelectPickers();
        },
        error: function () {
        }
    });
}

window.showRemoveItemFromCartModal = function(id, parent_unit_id = 0) {
    const modal = $('#removeItemFromCartModal');

    modal.css('z-index', 2000);

    modal.data('id', id);
    modal.data('parent_unit_id', parent_unit_id);

    modal.modal('show');

    // we have modal above modal, so we have to handle z-index
    $('.modal-backdrop').last().css('z-index', 1999);
}

window.hideRemoveItemFromCartModal = function() {
    // we have modal above modal, so we have to handle z-index
    const modal = $('#removeItemFromCartModal');

    $('.modal-backdrop').last().remove();

    modal.modal('hide');
}

window.removeItemFromCart = function(id = null, parent_unit_id = null) {
    const modal = $('#removeItemFromCartModal');

    id = id !== null ? id : modal.data('id');
    parent_unit_id = parent_unit_id !== null ? parent_unit_id : modal.data('parent_unit_id');

    let cartItems = localStorage.getItem('cart_items');

    if(!cartItems) {
        return;
    }

    cartItems = JSON.parse(cartItems);

    // Find the index of the item to remove
    let indexToRemove = -1;
    for (let i = 0; i < cartItems.length; i++) {
        if (generateCartItemId(cartItems[i].id, cartItems[i].unit_type) === id) {
            indexToRemove = i;
            break;
        }
    }

    // If item found, remove it from the array
    if (indexToRemove !== -1) {
        cartItems.splice(indexToRemove, 1);

        // Store the updated array back into local storage
        localStorage.setItem('cart_items', JSON.stringify(cartItems));

        window.cartItemsGlobal.splice(indexToRemove, 1)

        // remove row from dt
        $('[id="' + id + '"]').closest('tr').remove();

        if(id === generateCartItemId(window.currentLearningUnitId, window.currentLearningUnitType)) {
            location.reload();
            return;
        } else if(window.User.id !== 0) {
            sumCartPrice();
            regenerateSelectPickers();
        }
    }

    itemsCount = cartItems.length;

    setCartItemsNumber();

    if(itemsCount <= 0) {
        const modal = document.getElementById('bookingModal');
        
        if (modal) {
            modal.close();
        }

        if(window.location.href.includes("info")) {
            location.reload();
            return;
        }
    }

    if(parent_unit_id == window.currentLearningUnitId) {
        location.reload();
    }

    modal.modal('hide');
}

window.setCartItemsNumber = function() {
    if(!window.global_vars.masterdata.settings.shopping_cart) {
        return;
    }

    let cartItems = localStorage.getItem('cart_items')

    if (cartItems) {
        let itemsCount = JSON.parse(cartItems).length

        // increase cart items number
        let itemsCountString = itemsCount
        if (itemsCount > 9) {
            itemsCountString = "9+"
        }

        let cartIcon = document.getElementById('cart-icon')
        let cartNotification = document.getElementById('cart-notification')
        if (cartNotification && itemsCount !== 0) {
            cartNotification.textContent = itemsCountString
            cartNotification.style.visibility = 'visible'
            cartIcon.style.pointerEvents = 'auto'
            cartIcon.style.cursor = 'pointer'
        } else if(cartNotification) {
            cartNotification.textContent = "0"
            cartNotification.style.visibility = 'hidden'
            cartIcon.style.pointerEvents = 'none'
            cartIcon.style.cursor = 'default'
        }
    }
}

window.sumCartPrice = function () {
    try {

        if(window.cartItemsGlobal.length === 0) {
            return;
        }

        let sumOfPrice = 0;
        let allCurrenciesSame = true;
        let referenceCurrency = null;

        let priceAndCurrencyRegex = /(\d+)\s*(\S+)/;
        let selectedValues = Object.values(selectedUserLearningUnitDictionary).flat();

        for (const el of window.cartItemsGlobal) {
            let match = el.price.match(priceAndCurrencyRegex);

            let price = parseInt(match[1]);
            let currency = match[2];

            if (referenceCurrency === null) {
                referenceCurrency = currency;
            } else if (currency !== referenceCurrency) {
                allCurrenciesSame = false;
                break;
            }

            if(bookingForMyselfSet) {
                sumOfPrice += price;
            }

            if(bookingForOthersSet) {

                let selectedUnits = selectedValues.filter(selectedValue => {
                    return selectedValue === generateCartItemId(el.id, el.unit_type);
                });

                selectedUnits.forEach(() => {
                    sumOfPrice += price;
                });

            }
        }

        if(allCurrenciesSame) {
            $('#price').val(sumOfPrice);

            let priceHolder = document.getElementById('priceHolder');
            priceHolder.textContent = sumOfPrice;
            priceHolder.parentNode.style.display = "block";

            let currencyPlaceholder = document.getElementById('currencyHolder');
            currencyPlaceholder.textContent = referenceCurrency;
        } else {
            $('#priceHolder').parent().remove();
        }

    } catch (err) {
        console.log(err.message);
    }
}

window.updateClosedCourse = function(time, reload) { // , unitId = 0

    sessionStorage.setItem('course_active', 0);
    sessionStorage.setItem('iframe_active', 0);
    sessionStorage.setItem('popup_active', 0);

    setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: '/close/course',
            async: false,
            data: {
                // unit_id: unitId,
                page_path: window.location.pathname
            },
            success: function (response) {

                let unitId = response.unit_id

                if (window.location.href.includes("series") || window.location.href.includes("learning_box")) {
                    const uri = window.location.href;
                    const parts = uri.split('/');
                    const id = parts[parts.length - 2];

                    let mainObject = window.global_vars.unit_types.series
                    if (window.location.href.includes("learning_box")) {
                        mainObject = window.global_vars.unit_types.learning_box
                    }

                    loadUnitDetails(id, mainObject, id, [unitId, window.global_vars.unit_types.course]);

                    let iframeHolder = document.getElementById('iframe_holder')
                    if (iframeHolder) {
                        iframeHolder.src = "";
                    }

                    $('#course_overlay').hide();

                } else {

                    let iframeHolder = document.getElementById('iframe_holder')
                    if (iframeHolder) {
                        iframeHolder.src = "";
                    }

                    loadUnitDetails(unitId, window.global_vars.unit_types.course, null);

                    $('#course_overlay').hide();

                    if (response.unitMessage) {
                        window.notification('success', response.unitMessage)
                    }
                }

            }, error: function(err) {
                location.reload()
            }

        });
    }, time);
    if(typeof saveNotes !== 'undefined' && typeof saveNotes === 'function'){
        saveNotes(true);
    }
}

window.updateLockIcon = function(elem) {

    try {
        let seqItemLine = elem.parent().prev()

        let svgWrapper = seqItemLine.find('div.lock-icon')
        svgWrapper.addClass('unlock')
        svgWrapper.addClass('unlock-icon')
        svgWrapper.html('<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">\n' +
            '        <defs>\n' +
            '            <style>\n' +
            '                .unlock_icon_a{fill:#fff; stroke: var(--positiveTextColor) }\n' +
            '            </style>\n' +
            '        </defs>\n' +
            '        <path class="unlock_icon_a" d="M58,611.018a6.95,6.95,0,0,1,6.9-6.98,6.788,6.788,0,0,1,2.867.638v-1a5.615,5.615,0,1,1,11.229,0v1.552a.317.317,0,0,1-.316.32H76.471a.317.317,0,0,1-.316-.32v-1.552a2.77,2.77,0,1,0-5.54,0V607.1A6.931,6.931,0,1,1,58,611.018Zm.632,0a6.272,6.272,0,1,0,6.271-6.341A6.314,6.314,0,0,0,58.631,611.018Zm9.77-7.34v1.334a6.935,6.935,0,0,1,1.58,1.3v-2.63a3.4,3.4,0,1,1,6.8,0v1.233h1.58v-1.233a4.983,4.983,0,1,0-9.966,0Zm-3.815,11.011v-2.156a1.695,1.695,0,1,1,.632,0v2.156a.316.316,0,1,1-.632,0Zm-.746-3.838a1.063,1.063,0,1,0,1.062-1.075A1.069,1.069,0,0,0,63.841,610.852Z" transform="translate(-58 -598)"></path>\n' +
            '    </svg>')
    } catch (e) {
        console.log(e)
    }

}

window.loadUnitDetails = function(unit_id, unit_type, collectionId, currentItemData = []){

    window.currentLearningUnitId = unit_id;
    window.currentLearningUnitType = unit_type;

    const url = '/details/' + unit_id + '/' + unit_type;
    const loader    = $('#skeleton-wrapper-' + unit_id + '-' + unit_type);
    const unit  = unit_type !== 'meeting' ? $('#main-details-' + unit_type + '-' + unit_id) : $('*[data-meeting="' + unit_id + '"]');

    const match = window.location.href.match(/series|learning_box/);
    const collectionType = match ? match[0] : '';

    loader.fadeIn();

    $.ajax({
        type: 'GET',
        url: (collectionId && collectionId !== '') ? url + '/' + collectionId + '/' + collectionType : url,
        // async: false,
        data: {
            cart_items: localStorage.getItem('cart_items') || '',
            collection_id : collectionId,
            unit_type: unit_type
        },
        success: function (response) {
            // Hide skeleton
            loader.hide();

            const unit_parent = unit[0].parentElement;

            // Fill details and show
            unit.replaceWith(JSON.parse(response.html));

            // for series, update certificate icon if series was completed
            if (collectionId !== '' && response.unitSettings != undefined  && response.unitSettings.certificate_icon != undefined && response.unitSettings.certificate_icon != null) {
                $('#curriculum-certificate-icon-element').replaceWith(response.unitSettings.certificate_icon)
            }

            // used for seminars frontend progress bar
            let progressBar = $('#progress');
            if(progressBar) {
                progressBar.width(response.progress + '%');
            }

            // Resize every image to same size
            resizeImage(document.querySelector("#unit_image_"+unit_id+"_"+unit_type));
            // Show hide "Show more" button
            checkShowMoreButton(unit_id, unit_type);

            if (response.unitMessage) {
                window.notification('success', response.unitMessage)
            }

            if(localStorage.getItem('redirected_from_calendar') && unit_type == 'seminar') {
                // Refresh seminar meetings for seminar
                expandMeetingsSection(unit_id, collectionId, false);
                localStorage.removeItem('redirected_from_calendar');
            }

            if (collectionType !== '' && currentItemData.length > 0) { // dont refresh on initial load of the page

                if (response.unitSettings.has_optional_units) { // in case of optional units we can not relay on partial reloading of curriculum items, instead we reload the whole page
                    location.reload()
                }

                if (response.unitStatus === 100) { // refresh all units, because in case of booking they need to be disabled

                    $.each($('*[id^="main-details-"]:gt(0)'), function(index, value) {

                        let id = value.getAttribute('data-id')
                        let type = value.getAttribute('data-unit-type')

                        loadUnitDetails(id, type, collectionId);
                    })

                } else if (response.unitSettings.sequential == 0) { // refresh only closed unit (curriculum is already updated)
                    loadUnitDetails(currentItemData[0], currentItemData[1], collectionId);
                } else if (response.unitSettings.sequential == 1 && response.unitSettings.sequential_last_only == 0) { // refresh closed unit and the next one (curriculum is already updated)
                    let counter = 0
                    $.each($('*[id^="main-details-"]:gt(0)'), function(index, value) {
                        let id = value.getAttribute('data-id')
                        let type = value.getAttribute('data-unit-type')

                        if((id == currentItemData[0] && type == currentItemData[1]) || (counter > 0 && counter < 2)){
                            loadUnitDetails(id, type, collectionId);

                            // Refresh seminar meetings for seminar
                            if(type == 'seminar'){
                                expandMeetingsSection(id, collectionId, true);
                            }

                            counter++;

                            updateLockIcon($(this))
                        }

                    })

                } else if (response.unitSettings.sequential == 1 && response.unitSettings.sequential_last_only == 1) { // refresh closed unit and the last one (curriculum is already updated)

                    let counter = 0;
                    let len = $('*[id^="main-details-"]:gt(0)').length
                    $.each($('*[id^="main-details-"]:gt(0)'), function(index, value) {

                        counter++;

                        let id = value.getAttribute('data-id')
                        let type = value.getAttribute('data-unit-type')

                        if((id == currentItemData[0] && type == currentItemData[1]) || counter == len){
                            loadUnitDetails(id, type, collectionId);

                            // Refresh seminar meetings for seminar
                            if(type == 'seminar'){
                                expandMeetingsSection(id, collectionId, true);
                            }

                            updateLockIcon($(this))
                        }

                    })
                }

            }

            addClickEventListenerToRatingButton(unit_parent.querySelector('.rating-button'));
        }
    });
}

window.showProgressBar = function(animation = 'animate', cleartime = 2000) {
    const progressBar = document.querySelector('.progress-line');

    if (progressBar) {
        progressBar.classList.add(animation);

        setTimeout(function() {
            progressBar.classList.remove(animation);
        }, cleartime)
    }

}

window.registerDatatablePageTracker = function(table, tableId, storageKey) {
    $('#' + tableId).on('page.dt', function () {
        let pageInfo = table.page.info();
        sessionStorage.setItem(storageKey, pageInfo ? pageInfo.page : 0)
    });

    let currentPage = sessionStorage.getItem(storageKey)
    table.page(Number(currentPage ? currentPage : 0)).draw(false)
}

// only if first column in table contains row id
window.addUnitIdsToDatatableRowsAsIds = function(table, prefix) {
    let currentPageRows = table.rows().data();

    for (let i = 0; i < currentPageRows.length; i++) {
        let currentId = currentPageRows[i][0]; // Assuming the first column always contains the ID
        let rowNode = table.row(i).node(); // Get the DOM element for the row
        rowNode.id = prefix + currentId;
    }
};

window.checkShowMoreButton = function(unit_id, unit_type){
    let smb = document.getElementById('show-more_'+unit_type+'_'+unit_id);
    let ud = document.getElementById('unit-description_'+unit_type+'_'+unit_id);

    if(ud && checkOverflow(ud)){
        smb.classList.add('visible');
    }
    if(smb){
        smb.addEventListener("click", function(){
            expandShowMore(ud, smb);
        }, false);
    }
}

window.checkOverflow = function(el){
    var curOverflow = el.style.overflow;

    if ( !curOverflow || curOverflow === "visible" )
        el.style.overflow = "hidden";

    var isOverflowing = el.clientWidth < el.scrollWidth
        || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;

    return isOverflowing;
}
window.expandShowMore = function(desc, smb){
    desc.classList.toggle('increase-height');

    if(desc.classList.contains('increase-height')){
        smb.innerText = smb.dataset.less;
    }else{
        smb.innerText = smb.dataset.more;
    }
}

window.resizeImage = function(image){
    
    if(image){
        var currWidth = image.clientWidth;  
        var currHeight = image.clientHeight;
        if(currWidth/3 > currHeight) {

            image.style["height"] = currWidth*0.5 + "px";
        } else if(currHeight/2 > currWidth){

            // image.style["width"] = "100%";
            // image.style["width"] = currWidth*0.7 + "px";
        }
    }
}

window.getBrowser = function() {

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    if (isFirefox) {
        return 'FIREFOX';
    } else if(isIE) {
        return 'IE'
    }else{
        return 'OTHER'
    }

}

window.like = function(type, id){

    showProgressBar()

    $.ajax({
        type: 'POST',
        url: "/" + type + "/" + id + "/like",
        success: function (data) {
           // count.innerText = data.count;
            // let likeIcon = document.querySelector("#like_icon");
            // if(likeIcon){
            //     likeIcon.style.fill = data.color;
            // }

            let bu = document.getElementById('like-button_' + type + '_' + id)
            bu.getElementsByTagName('img')[0].src = data.image_url;

            let lc = document.getElementById('like-count_' + type + '_' + id)
            lc.textContent = data.count;

            if (data.pointsMessage !== null && data.pointsMessage !== undefined) {
                let message = data.pointsMessage;
                window.notification('success', message);

                let numberPattern = /\d+/g;

                let stringNumbers = message.match(numberPattern);

                if (stringNumbers.length > 0) {
                    window.updatePoints(stringNumbers[0]);
                }
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    [...document.getElementsByClassName('rating-star-container')].forEach(star => {
        let star_onclick = () => {
            starClicked(event.currentTarget.dataset.number);
        };
        star.addEventListener('click', star_onclick);
        star.addEventListener('keydown', () => {
            switch (event.key) {
                case ' ': {
                    event.preventDefault();
                    star_onclick();
                } break;

                case 'ArrowDown':
                case 'ArrowRight': {
                    event.preventDefault();
                    document.getElementById('rating-star-' + ((star.dataset.number) % 5 + 1)).focus();
                } break;

                case 'ArrowUp':
                case 'ArrowLeft': {
                    event.preventDefault();
                    document.getElementById('rating-star-' + (star.dataset.number == 1 ? 5 : (star.dataset.number - 1) % 5)).focus();
                } break;
            }

        });

        if(star.dataset.number == 1){
            star.tabIndex = 0;
        }

        let star_onfocus = () => {
            updateStarColours(event.currentTarget, true);
        };
        let star_onunfocus = () => {
            updateStarColours(event.currentTarget, false);
        };

        star.addEventListener('mouseenter', star_onfocus);
        star.addEventListener('focusin', star_onfocus);

        star.addEventListener('mouseleave', star_onunfocus);
        star.addEventListener('focusout', star_onunfocus);
    });

    [...document.getElementsByClassName('rating-button')].forEach(addClickEventListenerToRatingButton);
});

window.addClickEventListenerToRatingButton = (button) => {

    if (button) {
        button.addEventListener('click', () => {
            openRateModal(event.currentTarget.dataset.ratingPath, event.currentTarget.dataset.ratingId, event.currentTarget.dataset.userRating);
        });
        refreshStarFillLevel(button);
    }

};

window.refreshStarFillLevel = (button) => {
    let ratingAvg = Math.round(Number(button.querySelector('#rating-average_'+button.dataset.ratingId).innerText)*2)/2;
    button.querySelectorAll('.rating-small-star-icon').forEach((i) => {
        if(ratingAvg >= 1){
            i.querySelector('.rating-small-star-full').classList.remove('hidden');
        } else if(ratingAvg === 0.5){
            i.querySelector('.rating-small-star-half').classList.remove('hidden');
            i.querySelector('.rating-small-star-full').classList.add('hidden');
        } else{
            i.querySelector('.rating-small-star-half').classList.add('hidden');
            i.querySelector('.rating-small-star-full').classList.add('hidden');
        }

        ratingAvg--;
    });
};

window.openRateModal = (path, ratingId, userRating) => {
    event.stopPropagation();
    event.preventDefault();

    let ratingModal = document.getElementById('rating-modal');

    ratingModal.dataset.ratingPath = path;
    ratingModal.dataset.ratingId = ratingId;
    ratingModal.dataset.userRating = userRating;
    ratingModal.showModal();
    updateStarColours();
};

window.rateUnit = (csrf_token) => {
    let ratingModal = document.getElementById('rating-modal');

    let ratingBody = new FormData();
    ratingBody.append('stars', ratingModal.dataset.userRating);

    fetch(ratingModal.dataset.ratingPath, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'X-CSRF-Token': csrf_token,
        },
        body: ratingBody,
    })
    .then(response => response.json())
    .then((updatedRating) => {
        let id = ratingModal.dataset.ratingId;
        let button = document.getElementById('rating-button_'+id);
        button.dataset.userRating = updatedRating.userRating;
        document.getElementById('rating-average_'+id).innerText = Number(updatedRating.average).toFixed(1);
        document.getElementById('rating-count_'+id).innerText = updatedRating.count;

        refreshStarFillLevel(button);
    });

    document.getElementById('rating-modal').close();
};

window.updateStarColours = (star = null, enter = false, max_stars = 5) => {
    let rating = document.getElementById('rating-modal').dataset.userRating;
    let number = star ? star.dataset.number : 0;
    for(let i = 1; i <= max_stars; ++i){
        let starIcon = document.getElementById('rating-star-icon-'+i);
        let rating_star = document.getElementById('rating-star-'+i);

        rating_star.tabIndex = -1;
        rating_star.setAttribute('aria-checked', 'false');

        if(rating >= i){
            if(rating == i){
                rating_star.tabIndex = 0;
                rating_star.setAttribute('aria-checked', 'true');
            }

            if(i > number && enter){
                starIcon.style.fill = 'color-mix(in srgb, var(--ratingStarFillColor, orange) 50%, transparent)';
            } else {
                starIcon.style.fill = 'var(--ratingStarFillColor, orange)';
            }
            continue;
        }

        if(i <= number && enter){
            starIcon.style.fill = 'color-mix(in srgb, var(--ratingStarFillColor, orange) 50%, transparent)';
        } else{
            starIcon.style.fill = 'var(--ratingStarBackgroundColor, transparent)';
        }
    }
};

window.starClicked = (number) => {
    document.getElementById('rating-modal').dataset.userRating = number;
    updateStarColours();
};

window.goBrowserBack = function(forceReload = false) {

    if (forceReload) {
        sessionStorage.setItem('back-button-reload', 1);
    }

    window.history.back()
}

window.addEventListener('pageshow', (event) => {
    let forceReload = sessionStorage.getItem('back-button-reload');

    sessionStorage.setItem('back-button-reload', 0);

    if (forceReload == 1 && event.persisted) {
        location.reload();
    }
});

window.generateCartItemId = function (id, unit_type) {
    if(unit_type === 'media') {
        unit_type = window.global_vars.unit_types.content_media;
    }
    else if(unit_type === 'pdf') {
        unit_type = window.global_vars.unit_types.pdfdocument;
    }

    return `${id}:::${unit_type}`;
}

function handleFormSubmit(event) {
    // Find submit button with specified classes (all buttons)
    var submitButton = $(this).find('.btn.btn-primary.positive');

    // If button found, disable it (all buttons)
    if (submitButton.length > 0) {
        submitButton.prop("disabled", true);

        // Enable the button again after 2 seconds (all buttons)
        setTimeout(function () {
            submitButton.prop("disabled", false);
        }, 2000);
    }

    // Allow default form submission
    return true;
}

function handleModalFormSubmit(event) {
  if ($(this).closest('.modal').length > 0) {
      // Find and disable modal submit button
      var submitButtonInModal = $(this).closest('.modal').find('.btn.btn-primary.positive');
      submitButtonInModal.prop("disabled", true);

      // Shorter re-enable delay (optional)
      setTimeout(function () {
          submitButtonInModal.prop("disabled", false);
      }, 1000); // Adjust delay as needed
  }

  // Allow default form submission
  return true;
}

$(document).ready(function() {
    // Use event delegation for dynamically loaded content
    $(document).on('submit', 'form', handleFormSubmit);
    $(document).on('submit', '.modal form', handleModalFormSubmit); // Target modal forms
});


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/global_general.js